(() => {
  'use strict';

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));

  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(amount);
    } catch (e) {
      return `R$ ${amount.toFixed(2).replace('.', ',')}`;
    }
  }

  function showToast(message) {
    const toast = qs('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => toast.classList.remove('is-visible'), 2600);
  }

  function setBodyLock(locked) {
    document.body.classList.toggle('is-locked', locked);
  }

  function openDrawer(drawer) {
    if (!drawer) return;
    qsa('.drawer.is-open').forEach((item) => {
      if (item !== drawer) closeDrawer(item, false);
    });
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    setBodyLock(true);
    const focusable = drawer.querySelector('button, input, a, select, textarea');
    if (focusable) window.setTimeout(() => focusable.focus(), 180);
  }

  function closeDrawer(drawer, unlock = true) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (unlock && !qs('.drawer.is-open')) setBodyLock(false);
  }

  function initDrawers() {
    const cart = qs('[data-cart-drawer]');
    const search = qs('[data-search-drawer]');
    const menu = qs('[data-mobile-menu]');

    qsa('[data-open-cart]').forEach((el) => el.addEventListener('click', () => openDrawer(cart)));
    qsa('[data-close-cart]').forEach((el) => el.addEventListener('click', () => closeDrawer(cart)));
    qsa('[data-open-search]').forEach((el) => el.addEventListener('click', () => {
      openDrawer(search);
      const input = qs('[data-predictive-search-input]', search);
      if (input) window.setTimeout(() => input.focus(), 220);
    }));
    qsa('[data-close-search]').forEach((el) => el.addEventListener('click', () => closeDrawer(search)));
    qsa('[data-open-menu]').forEach((el) => el.addEventListener('click', () => openDrawer(menu)));
    qsa('[data-close-menu]').forEach((el) => el.addEventListener('click', () => closeDrawer(menu)));

    qsa('.mobile-nav__toggle').forEach((button) => {
      button.addEventListener('click', () => {
        const submenu = button.parentElement && button.parentElement.querySelector('.mobile-nav__submenu');
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        if (submenu) submenu.classList.toggle('is-open', !expanded);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      qsa('.drawer.is-open').forEach((drawer) => closeDrawer(drawer));
    });
  }

  function initHeroSliders(scope = document) {
    qsa('[data-hero-slider]', scope).forEach((slider) => {
      if (slider.dataset.initialized === 'true') return;
      slider.dataset.initialized = 'true';
      const slides = qsa('[data-hero-slide]', slider);
      const dots = qsa('[data-hero-dot]', slider);
      if (slides.length <= 1) return;

      let current = 0;
      let timer;
      const speed = Number(slider.dataset.speed || 6000);
      const autoplay = slider.dataset.autoplay === 'true';

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
        dots.forEach((dot, i) => {
          const active = i === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
      };
      const stop = () => clearInterval(timer);
      const start = () => {
        stop();
        if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = setInterval(() => show(current + 1), speed);
        }
      };

      qs('[data-hero-prev]', slider)?.addEventListener('click', () => { show(current - 1); start(); });
      qs('[data-hero-next]', slider)?.addEventListener('click', () => { show(current + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.heroDot)); start(); }));
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);
      start();
    });
  }

  function initBrandTabs(scope = document) {
    qsa('[data-brand-tabs]', scope).forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      qsa('[data-brand-tab]', section).forEach((button) => {
        button.addEventListener('click', () => {
          const id = button.dataset.brandTab;
          qsa('[data-brand-tab]', section).forEach((b) => {
            const active = b === button;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-selected', String(active));
          });
          qsa('[data-brand-panel]', section).forEach((panel) => panel.classList.toggle('is-active', panel.dataset.brandPanel === id));
        });
      });
    });
  }

  function initFavorites(scope = document) {
    qsa('[data-favorite-button]', scope).forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        button.classList.toggle('is-active');
        showToast(button.classList.contains('is-active') ? 'Salvo nos favoritos deste dispositivo' : 'Removido dos favoritos');
      });
    });
  }

  function renderCart(cart) {
    const body = qs('[data-cart-drawer-body]');
    const footer = qs('[data-cart-drawer-footer]');
    const countEls = qsa('[data-cart-count]');
    const heading = qs('[data-cart-count-heading]');
    const subtotal = qs('[data-cart-subtotal]');

    countEls.forEach((el) => el.textContent = cart.item_count);
    if (heading) heading.textContent = `(${cart.item_count})`;
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = `
        <div class="cart-empty">
          <span><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5.5 8.5h13l-.8 12h-11.4l-.8-12Z"></path><path d="M9 9V6a3 3 0 0 1 6 0v3"></path></svg></span>
          <h3>Seu carrinho está vazio</h3><p>Encontre seus próximos favoritos de beleza.</p>
          <a class="button button--wine" href="${root}collections/all">Explorar produtos</a>
        </div>`;
      footer?.classList.add('is-hidden');
      return;
    }

    body.innerHTML = cart.items.map((item) => {
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<span class="cart-line__variant">${escapeHtml(item.variant_title)}</span>` : '';
      const image = item.image ? `<img src="${escapeHtml(item.image)}&width=220" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '';
      return `
        <div class="cart-line" data-line-key="${escapeHtml(item.key)}">
          <a href="${escapeHtml(item.url)}" class="cart-line__image">${image}</a>
          <div class="cart-line__info">
            <a class="cart-line__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
            ${variant}
            <div class="cart-line__bottom">
              <div class="qty-control"><button type="button" data-cart-qty-minus data-key="${escapeHtml(item.key)}" aria-label="Diminuir quantidade">−</button><span>${item.quantity}</span><button type="button" data-cart-qty-plus data-key="${escapeHtml(item.key)}" aria-label="Aumentar quantidade">+</button></div>
              <strong>${formatMoney(item.final_line_price)}</strong>
            </div>
          </div>
          <button class="cart-line__remove" type="button" data-cart-remove data-key="${escapeHtml(item.key)}" aria-label="Remover item"><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m6 6 12 12M18 6 6 18"></path></svg></button>
        </div>`;
    }).join('');
    footer?.classList.remove('is-hidden');
    bindCartControls();
  }

  async function fetchCart() {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Não foi possível atualizar o carrinho.');
    return response.json();
  }

  async function changeCart(key, quantity) {
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!response.ok) throw new Error('Erro ao atualizar item.');
      renderCart(await response.json());
    } catch (error) {
      showToast(error.message || 'Não foi possível atualizar o carrinho.');
    }
  }

  function bindCartControls() {
    qsa('[data-cart-remove]').forEach((button) => {
      button.onclick = () => changeCart(button.dataset.key, 0);
    });
    qsa('[data-cart-qty-minus]').forEach((button) => {
      button.onclick = () => {
        const line = button.closest('.cart-line');
        const current = Number(qs('.qty-control span', line)?.textContent || 1);
        changeCart(button.dataset.key, Math.max(0, current - 1));
      };
    });
    qsa('[data-cart-qty-plus]').forEach((button) => {
      button.onclick = () => {
        const line = button.closest('.cart-line');
        const current = Number(qs('.qty-control span', line)?.textContent || 1);
        changeCart(button.dataset.key, current + 1);
      };
    });
  }

  function initAjaxCartForms(scope = document) {
    qsa('.js-ajax-cart-form', scope).forEach((form) => {
      if (form.dataset.ajaxBound === 'true') return;
      form.dataset.ajaxBound = 'true';
      form.addEventListener('submit', async (event) => {
        if (event.submitter && event.submitter.closest && event.submitter.closest('.shopify-payment-button')) return;
        event.preventDefault();
        const button = event.submitter || qs('[type="submit"]', form);
        const originalText = button?.textContent;
        if (button) { button.disabled = true; button.textContent = 'Adicionando...'; }
        try {
          const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Não foi possível adicionar ao carrinho.');
          const cart = await fetchCart();
          renderCart(cart);
          openDrawer(qs('[data-cart-drawer]'));
          showToast('Produto adicionado ao carrinho');
        } catch (error) {
          showToast(error.message || 'Não foi possível adicionar ao carrinho.');
        } finally {
          if (button) { button.disabled = false; button.textContent = originalText; }
        }
      });
    });
  }

  function initPredictiveSearch() {
    const drawer = qs('[data-search-drawer]');
    const input = qs('[data-predictive-search-input]', drawer);
    const results = qs('[data-predictive-search-results]', drawer);
    const allLink = qs('[data-search-all-link]', drawer);
    if (!input || !results || input.dataset.bound === 'true') return;
    input.dataset.bound = 'true';
    let controller;
    let timer;

    input.addEventListener('input', () => {
      clearTimeout(timer);
      const term = input.value.trim();
      if (allLink) allLink.href = `${root}search?q=${encodeURIComponent(term)}&options%5Bprefix%5D=last`;
      if (term.length < 2) {
        results.innerHTML = '<div class="search-drawer__empty"><p>Digite ao menos 2 letras para pesquisar.</p></div>';
        return;
      }
      timer = setTimeout(async () => {
        if (controller) controller.abort();
        controller = new AbortController();
        results.innerHTML = '<div class="search-drawer__empty"><p>Buscando...</p></div>';
        try {
          const url = `${root}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
          const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error();
          const data = await response.json();
          const products = data?.resources?.results?.products || [];
          if (!products.length) {
            results.innerHTML = '<div class="search-drawer__empty"><p>Nenhum produto encontrado.</p></div>';
            return;
          }
          results.innerHTML = products.map((product) => {
            const image = product.image ? `<img src="${escapeHtml(product.image)}&width=160" alt="${escapeHtml(product.title)}" loading="lazy">` : '';
            const numericPrice = Number(product.price);
            const price = Number.isFinite(numericPrice) ? `<span>${formatMoney(numericPrice)}</span>` : '';
            return `<a class="predictive-item" href="${escapeHtml(product.url)}">${image}<div><strong>${escapeHtml(product.title)}</strong>${product.vendor ? `<small>${escapeHtml(product.vendor)}</small>` : ''}</div>${price}</a>`;
          }).join('');
        } catch (error) {
          if (error.name !== 'AbortError') results.innerHTML = '<div class="search-drawer__empty"><p>Não foi possível carregar a pesquisa agora.</p></div>';
        }
      }, 260);
    });
  }

  function initProduct(scope = document) {
    qsa('[data-product-section]', scope).forEach((section) => {
      qsa('[data-product-thumb]', section).forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const id = thumb.dataset.productThumb;
          qsa('[data-product-thumb]', section).forEach((item) => item.classList.toggle('is-active', item === thumb));
          qsa('[data-media-id]', section).forEach((media) => media.classList.toggle('is-active', media.dataset.mediaId === id));
        });
      });
      const qty = qs('[data-product-qty]', section);
      qs('[data-product-qty-minus]', section)?.addEventListener('click', () => { if (qty) qty.value = Math.max(1, Number(qty.value || 1) - 1); });
      qs('[data-product-qty-plus]', section)?.addEventListener('click', () => { if (qty) qty.value = Number(qty.value || 1) + 1; });

      const variantSelect = qs('[data-variant-select]', section);
      const variantJson = qs('[data-product-variants]', section);
      if (variantSelect && variantJson) {
        let variants = [];
        try { variants = JSON.parse(variantJson.textContent); } catch (e) { variants = []; }
        variantSelect.addEventListener('change', () => {
          const variant = variants.find((item) => String(item.id) === String(variantSelect.value));
          if (!variant) return;
          const priceBox = qs('[data-product-price]', section);
          if (priceBox) {
            const compare = variant.compare_at_price && variant.compare_at_price > variant.price ? `<span class="price__compare">${formatMoney(variant.compare_at_price)}</span>` : '';
            priceBox.innerHTML = `<div class="price${compare ? ' price--sale' : ''}"><span class="price__current">${formatMoney(variant.price)}</span>${compare}</div>`;
          }
          try {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);
          } catch (e) {}
        });
      }
    });
  }

  function initAll(scope = document) {
    initHeroSliders(scope);
    initBrandTabs(scope);
    initFavorites(scope);
    initAjaxCartForms(scope);
    initProduct(scope);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initDrawers();
    initPredictiveSearch();
    bindCartControls();
    initAll(document);
  });

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
